import oregon from '../assets/Home/TKO.jpg';
import traditional from '../assets/Home/traditionalLeoTransparent.png';
import arks from '../assets/Home/ngs_arks_logo.png';
import discordApp from '../assets/Home/icons8-discord-256.png';
import '../project/Project.css';

export default function Project() {
    return (
        <div className='Project'>
            <section className='Project-main'>
                <h1>
                    Projects
                </h1>
                <div className='Project-container'>
                    <a href='https://trailkeepersoforegon.org/'>
                        <article className='Project-example'>
                            <h3>
                                Trailkeepers of Oregon
                            </h3>
                            <p>
                                <strong>
                                    PHP, Wordpress
                                </strong>
                                    - Hiking and exploring community
                            </p>
                            <img src={oregon} className="Project-icon-image" alt="trailkeepers of Oregon" />
                        </article>
                    </a>
                    <a href='https://traditionalleo.netlify.app/'>
                        <article className='Project-example'>
                            <h3>
                                Traditional Leo
                            </h3>
                            <p>
                                <strong>
                                    HTML, CSS, JavaScript, Node, Express
                                </strong>
                                    - Barber haircut business
                            </p>
                            <img src={traditional} className="Project-icon-image" alt="traditonal leo" />
                        </article>
                    </a>
                </div>
                <div className='Project-container'>
                    <a href='https://arksgenerator.netlify.app/'>
                        <article className='Project-example'>
                            <h3>
                                ARKS Card Generator
                            </h3>
                            <p>
                                <strong>
                                    HTML, CSS, JavaScript, Node, Express
                                </strong>
                                    - Generate ARKS Card for players
                            </p>
                            <img src={arks} className="Project-icon-image" alt="ARKS Generator" />
                        </article>
                    </a>
                    <a href='https://polybots.netlify.app/'>
                        <article className='Project-example'>
                            <h3>
                                Polybot
                            </h3>
                            <p>
                                <strong>
                                    JavaScript
                                </strong>
                                    - Discord music bot
                            </p>
                            <img src={discordApp} className="Project-icon-image" alt="discord music bot" />
                        </article>
                    </a>
                </div>
            </section>
        </div>
    )
}